import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthorizationContext, SessionAdmin } from "../types/auth";
import { clearStoredSession, readStoredUser } from "../utils/authStorage";
import { isTokenCurrent } from "../utils/tokenUtils";

interface AuthState {
  isAuthenticated: boolean;
  accessToken: string | null;
  refreshToken: string | null;
  user: SessionAdmin | null;
  tokenExpiration: number | null;
  authorization: AuthorizationContext | null;
  sessionGeneration: number;
}
if (!isTokenCurrent(localStorage.getItem("accessToken")) && !isTokenCurrent(localStorage.getItem("refreshToken"))) clearStoredSession();
const initialState: AuthState = {
  isAuthenticated: !!(localStorage.getItem("accessToken") || localStorage.getItem("refreshToken")),
  accessToken: localStorage.getItem("accessToken"),
  refreshToken: localStorage.getItem("refreshToken"),
  user: readStoredUser<SessionAdmin>(),
  tokenExpiration: Number(localStorage.getItem("tokenExpiration")) || null,
  authorization: null,
  sessionGeneration: 0,
};

const authSlice = createSlice({
  name: "auth", initialState,
  reducers: {
    login: (state, action: PayloadAction<{ accessToken: string; refreshToken: string; user: SessionAdmin; exp: number }>) => {
      state.sessionGeneration += 1;
      state.isAuthenticated = true;
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.user = action.payload.user;
      state.tokenExpiration = action.payload.exp;
      state.authorization = null;
      localStorage.setItem("accessToken", action.payload.accessToken);
      localStorage.setItem("refreshToken", action.payload.refreshToken);
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      localStorage.setItem("tokenExpiration", String(action.payload.exp));
    },
    logout: state => {
      state.sessionGeneration += 1;
      state.isAuthenticated = false;
      state.accessToken = null; state.refreshToken = null; state.user = null;
      state.tokenExpiration = null; state.authorization = null;
      clearStoredSession();
    },
    updateProfilePicture: (state, action: PayloadAction<string | null>) => {
      if (state.user) {
        state.user.avatarUrl = action.payload;
        localStorage.setItem("user", JSON.stringify(state.user));
      }
    },
    setAuthorization: (state, action: PayloadAction<AuthorizationContext>) => { state.authorization = action.payload; },
    updateSessionAdmin: (state, action: PayloadAction<SessionAdmin>) => {
      state.user = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    replaceSessionTokens: (state, action: PayloadAction<{ accessToken: string; refreshToken: string; exp: number }>) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.tokenExpiration = action.payload.exp;
      localStorage.setItem("accessToken", action.payload.accessToken);
      localStorage.setItem("refreshToken", action.payload.refreshToken);
      localStorage.setItem("tokenExpiration", String(action.payload.exp));
    },
  },
});
export const { login, logout, updateProfilePicture, setAuthorization, updateSessionAdmin, replaceSessionTokens } = authSlice.actions;
export default authSlice.reducer;
